import React from "react";
import { useLocation } from "react-router-dom";
import IpDashboardLegacy from "./s-item-2-Dashboard-Network-Legacy.jsx";
import NetworkSecurityCenter from "./network/NetworkSecurityCenter.jsx";

const IpDashboard = () => {
  const { search } = useLocation();
  const requestedView = new URLSearchParams(search).get("networkDashboard");
  const v3Enabled =
    String(process.env.REACT_APP_NETWORK_DASHBOARD_V3).toLowerCase() === "true";

  const showV3 =
    requestedView === "v3" || (requestedView !== "legacy" && v3Enabled);

  return showV3 ? <NetworkSecurityCenter /> : <IpDashboardLegacy />;
};

export default IpDashboard;
